module.exports = __webpack_public_path__ + "media/ר.1395113e.mp3";